"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var codes = require("./codes.json");

var removeDiacritics = require('diacritics').remove;

var registeredLocales = {};
/*
 * All codes map to ISO 3166-1 alpha-2
 */

var alpha2 = {},
    alpha3 = {},
    numeric = {},
    invertedNumeric = {};
codes.forEach(function (codeInformation) {
  var s = codeInformation;
  alpha2[s[0]] = s[1];
  alpha3[s[1]] = s[0];
  numeric[s[2]] = s[0];
  invertedNumeric[s[0]] = s[2];
});

function formatNumericCode(code) {
  return String('000' + (code ? code : '')).slice(-3);
}

function registerLocale(localeData) {
  if (!localeData.locale) {
    throw new TypeError('Missing localeData.locale');
  }

  if (!localeData.countries) {
    throw new TypeError('Missing localeData.countries');
  }

  registeredLocales[localeData.locale] = localeData.countries;
}

exports.registerLocale = registerLocale;
/*
 * @param code Alpha-3 code
 * @return Alpha-2 code or undefined
 */

function alpha3ToAlpha2(code) {
  return alpha3[code];
}

exports.alpha3ToAlpha2 = alpha3ToAlpha2;
/*
 * @param code Alpha-2 code
 * @return Alpha-3 code or undefined
 */

function alpha2ToAlpha3(code) {
  return alpha2[code];
}

exports.alpha2ToAlpha3 = alpha2ToAlpha3;
/*
 * @param code Alpha-3 code
 * @return Numeric code or undefined
 */

function alpha3ToNumeric(code) {
  return invertedNumeric[alpha3ToAlpha2(code)];
}

exports.alpha3ToNumeric = alpha3ToNumeric;
/*
 * @param code Alpha-2 code
 * @return Numeric code or undefined
 */

function alpha2ToNumeric(code) {
  return invertedNumeric[code];
}

exports.alpha2ToNumeric = alpha2ToNumeric;
/*
 * @param code Numeric code
 * @return Alpha-3 code or undefined
 */

function numericToAlpha3(code) {
  var padded = formatNumericCode(code);
  return alpha2ToAlpha3(numeric[padded]);
}

exports.numericToAlpha3 = numericToAlpha3;
/*
 * @param code Numeric code
 * @return Alpha-2 code or undefined
 */

function numericToAlpha2(code) {
  var padded = formatNumericCode(code);
  return numeric[padded];
}

exports.numericToAlpha2 = numericToAlpha2;
/*
 * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
 * @return ISO 3166-1 alpha-3
 */

function toAlpha3(code) {
  if (typeof code === "string") {
    if (/^[0-9]*$/.test(code)) {
      return numericToAlpha3(code);
    }

    if (code.length === 2) {
      return alpha2ToAlpha3(code.toUpperCase());
    }

    if (code.length === 3) {
      return code.toUpperCase();
    }
  }

  if (typeof code === "number") {
    return numericToAlpha3(code);
  }

  return undefined;
}

exports.toAlpha3 = toAlpha3;
/*
 * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
 * @return ISO 3166-1 alpha-2
 */

function toAlpha2(code) {
  if (typeof code === "string") {
    if (/^[0-9]*$/.test(code)) {
      return numericToAlpha2(code);
    }

    if (code.length === 2) {
      return code.toUpperCase();
    }

    if (code.length === 3) {
      return alpha3ToAlpha2(code.toUpperCase());
    }
  }

  if (typeof code === "number") {
    return numericToAlpha2(code);
  }

  return undefined;
}

exports.toAlpha2 = toAlpha2;
/*
 * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
 * @param lang language for country name
 * @return name or undefined
 */

exports.getName = function (code, lang) {
  try {
    var codeMaps = registeredLocales[lang.toLowerCase()];
    var names = codeMaps[toAlpha2(code)];
    return Array.isArray(names) ? names[0] : names;
  } catch (err) {
    return undefined;
  }
};
/*
 * @param lang language for country names
 * @return Object of country code mapped to county name
 */


exports.getNames = function (lang) {
  var d = registeredLocales[lang.toLowerCase()];

  if (d === undefined) {
    return {};
  }

  return d;
};
/*
 * @param name name
 * @param lang language for country name
 * @return ISO 3166-1 alpha-2 or undefined
 */


exports.getAlpha2Code = function (name, lang) {
  var normalizeString = function normalizeString(string) {
    return string.toLowerCase();
  };

  var areSimilar = function areSimilar(a, b) {
    return normalizeString(a) === normalizeString(b);
  };

  try {
    var codenames = registeredLocales[lang.toLowerCase()];

    for (var p in codenames) {
      if (!codenames.hasOwnProperty(p)) {
        continue;
      }

      if (typeof codenames[p] === "string") {
        if (areSimilar(codenames[p], name)) {
          return p;
        }
      }

      if (Array.isArray(codenames[p])) {
        var _iterator = _createForOfIteratorHelper(codenames[p]),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var mappedName = _step.value;

            if (areSimilar(mappedName, name)) {
              return p;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }

    return undefined;
  } catch (err) {
    return undefined;
  }
};
/*
 * @param name name
 * @param lang language for country name
 * @return ISO 3166-1 alpha-2 or undefined
 */


exports.getSimpleAlpha2Code = function (name, lang) {
  var normalizeString = function normalizeString(string) {
    return removeDiacritics(string.toLowerCase());
  };

  var areSimilar = function areSimilar(a, b) {
    return normalizeString(a) === normalizeString(b);
  };

  try {
    var codenames = registeredLocales[lang.toLowerCase()];

    for (var p in codenames) {
      if (!codenames.hasOwnProperty(p)) {
        continue;
      }

      if (typeof codenames[p] === "string") {
        if (areSimilar(codenames[p], name)) {
          return p;
        }
      }

      if (Array.isArray(codenames[p])) {
        var _iterator2 = _createForOfIteratorHelper(codenames[p]),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var mappedName = _step2.value;

            if (areSimilar(mappedName, name)) {
              return p;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }

    return undefined;
  } catch (err) {
    return undefined;
  }
};
/*
 * @return Object of alpha-2 codes mapped to alpha-3 codes
 */


exports.getAlpha2Codes = function () {
  return alpha2;
};
/*
 * @param name name
 * @param lang language for country name
 * @return ISO 3166-1 alpha-3 or undefined
 */


exports.getAlpha3Code = function (name, lang) {
  var alpha2 = this.getAlpha2Code(name, lang);

  if (alpha2) {
    return this.toAlpha3(alpha2);
  } else {
    return undefined;
  }
};
/*
 * @param name name
 * @param lang language for country name
 * @return ISO 3166-1 alpha-3 or undefined
 */


exports.getSimpleAlpha3Code = function (name, lang) {
  var alpha2 = this.getSimpleAlpha2Code(name, lang);

  if (alpha2) {
    return this.toAlpha3(alpha2);
  } else {
    return undefined;
  }
};
/*
 * @return Object of alpha-3 codes mapped to alpha-2 codes
 */


exports.getAlpha3Codes = function () {
  return alpha3;
};
/*
 * @return Object of numeric codes mapped to alpha-2 codes
 */


exports.getNumericCodes = function () {
  return numeric;
};
/*
 * @return Array of supported languages
 */


exports.langs = function () {
  return Object.keys(registeredLocales);
};
/*
 * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
 * @return Boolean
 */


exports.isValid = function (code) {
  if (!code) {
    return false;
  }

  var coerced = code.toString().toUpperCase();
  return alpha3.hasOwnProperty(coerced) || alpha2.hasOwnProperty(coerced) || numeric.hasOwnProperty(coerced);
};